export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ancien mot de passe"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nouveau mot de passe"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmation du mot de passe"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enregistrer"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["\"Nouveau mot de passe\" et \"Confirmation du mot de passe\" ne correspondent pas."])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Changer le mot de passe"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chaîne de 4 à 63 caractères. Les caractères autorisés sont les lettres de l'alphabet latin, les chiffres et les symboles"])},
  "strength": {
    "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vide"])},
    "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faible"])},
    "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Moyen"])},
    "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fort"])}
  }
}